module.exports = __webpack_public_path__ + "img/speaker-ShotaArveladze-video.b1cb04fc.png";